export function isTopPositive (el) {
  const rect = el.getBoundingClientRect()
  return rect.top >= 0
}
